import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { EXCHANGE_API_BASE_URL, rpc } from "../common"; // @todo: @circlehotarux write type

export var getOrdersHistory = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userAddr, page, perpage) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", rpc.post("", {
              id: 1,
              jsonrpc: '2.0',
              method: 'tokenlon.getOrdersHistory',
              params: {
                userAddr: userAddr,
                page: page,
                perpage: perpage
              }
            }, {
              baseURL: EXCHANGE_API_BASE_URL
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getOrdersHistory(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();